import AV from 'leancloud-storage'

export const User = AV.User

/**
 * 账号密码登录
 */
User.logInByAccount = function (phone, password) {
    return AV.User.logInWithMobilePhone(phone, password)
}

/**
 * 检测手机号是否已注册
 */
User.checkPhoneExist = function (phone) {
    return AV.Cloud.run('checkMobilePhoneNumberExist', { phone })
}

/**
 * 获取不重复的用户名
 * @param {} username
 */
User.getNonRepetitiveUsername = function (username) {
    return AV.Cloud.run("getNonRepetitiveUsername", { username: username })
}

/**
 * 发送验证码
 * @param {*} phone
 */
User.requestSmsCode = function (phone, validateToken) {
    return AV.Cloud.requestSmsCode({
        mobilePhoneNumber: phone,
        name: '西窗烛',
        op: '验证手机号',
        ttl: 10
    }, { validateToken })
}

/**
 * 账号密码登录
 */
User.setInfo = function (username, password) {
    let user = User.current()

    user.setUsername(username)
    user.setPassword(password)

    return user.save()
}

/**
 * 微信登录
 */
User.logInByWechat = function (code) {
    return AV.Cloud.run('logInByWechat', { code })
}

/**
 * QQ 登录
 */
User.logInByQQ = function (code) {
    return AV.Cloud.run('logInByQQ', { code })
}

/**
 * 微博登录
 */
User.logInByWeibo = function (code) {
    return AV.Cloud.run('logInByWeibo', { code })
}

User.getLikedWorks = function (page = 1, perPage = 10) {
    return AV.Cloud.run('getUserLikedWorks', {
        page,
        perPage
    })
}

User.getAllLikedWorks = function () {
    return AV.Cloud.run('getUserLikedWorks', {
        page: 1,
        perPage: 1000
    })
}

// 得到部分User属性，目前用于个人中心
User.getMiniDataById = function (userId) {
    return AV.Cloud.rpc('getMiniUserById', {
        userId
    })
}



// WEBPACK FOOTER //
// ./src/models/user.js